<template>
  <div>
              <div
                class="row p-l15-r15 p-t20"
                v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true"
              >
                <div class="row p-t10-b10">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="class-suggestion-notes">
                      <span class="class-super-heading-notes">Your Results</span>
                    </div>
                  </div>
                </div>
                <div class="row p-t10-b10">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="class-suggestion-notes">
                      <span class="class-header">Class</span>
                    </div>
                  </div>
                </div>
                <div class="row p-t10-b10">
                  <div class="col-lg-5 col-md-5 col-sm-1 col-xs-1">
                  </div>
                  <div class="col-lg-2 col-md-2 col-sm-10 col-xs-10">
                        <div
                        class="circle"
                      ><span class="class-code-style" v-if="kitClassSummary.classCode === 'Not Applicable'">NA</span>
                      <span
                      :class="{
                        'class-code-style class-code-style-font':
                        kitClassSummary.classCodePfx !== 'AIMD',
                        'class-code-style class-code-style-font-small': kitClassSummary.classCodePfx === 'AIMD',
                      }"
                       v-else>{{kitClassSummary.classCodeSfx?kitClassSummary.classCodeSfx:kitClassSummary.classCodePfx}}</span>
                      </div>
                  </div>
                  <div class="col-lg-5 col-md-5 col-sm-1 col-xs-1">
                  </div>
                </div>
                <div class="row p-t10-b10">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="hr">
                      <hr/>
                    </div>
                  </div>
                </div>
                <div class="row p-t10-b10">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="class-suggestion-notes">
                      {{prodClassCriteria.country}} classification is based on inputs provided.
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="class-notes" v-html="summarizedRiskClassRules.resultingRiskClass[1]"></div>
                  </div>
                </div>
                <br>
                <div class="row" v-if="prodClassCriteria.country === 'EU IVDR' && sortedLevelArrayKitSize === 1">
                  <div class="col-sm-offset-4 col-md-4 col-sm-4 col-xs-12">
                    <div class="class-notes">{{pageConfig.IVDRClassificationNote}}</div>
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true">
                <div class="col-md-12 col-ms-12 col-xs-12">
                    <div class="hr-thin"><hr/></div>
                </div>
              </div>
              <div v-if="prodClassCriteria.country === 'EU MDR' || prodClassCriteria.country === 'EU IVDR'">
              <div
                class="row"
                v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading">For Purchase</div>
              </div>
              <div class="row alert-detail p-t10-b10"  v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><button
                  class="btn btn-block prev-slide emergo-blue-button float-right m-t5"
                  @click="this.$parent.checkMarketPlaceWrapperForRationaleReport">Rationale Report</button></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
              </div>
              <div class="row alert-detail p-t10-b10"  v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true">
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"><button id="mktPlaceProdClassTwo"  class="btn btn-block emergo-blue-button float-right prev-slide"
                    @click="regPathwayRouterWrapper">Regulatory Essentials Report</button></div>
                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
              </div>
              </div>
              <div
                class="disclaimer margin_top_bottom_15"
                v-if="prodClassCriteria.compositeArrayWrapper.classFoundFlag == true && prodClassCriteria.current_slide_number === 3"
              >
                <br/>Disclaimer: This assesment is not intended to replace an in-depth analysis of your company's circumstances, replace a gap analysis
                or discourage or prevent you or your company from taking appropriate and timely action.
                Reports are general in nature, not individualized to any particular product or manufacturer, and do not constitute a definitive or comprehensive statement of regulatory information. Emergo by UL is separately available to provide consulting services with respect to the regulatory processes applicable to particular products in specific markets.
              </div>
  </div>
</template>
<script>
const REG_PATHWAY_PLAN_ID = 8;
const REG_PATHWAY_SVC_ID = 7;
export default {
  props: [
    'account_id', 'roleId', 'userId',
    'prodClassCriteria',
    'debug',
    'kitClassSummary',
    'info',
    'compositeArrayWrapper', 'pageConfig', 'ivdrKitFlow',
  ],
  data() {
    return {
      activeNames: [''],
    };
  },
  methods: {
    regPathwayRouterWrapper() {
      if (this.$parent.checkSubscriptionStatusForPlan(REG_PATHWAY_PLAN_ID)) {
        this.$router.push({ path: `/layout/market-place/service/${REG_PATHWAY_SVC_ID}` });
      }
      this.$router.push({ path: this.$parent.regPathwayPlanRouteMap.get(REG_PATHWAY_PLAN_ID), params: { searchCriteria: this.prodClassCriteria, accountId: this.account_id, userId: this.userId } });
    },
  },
  computed: {
    /* classData() {
      const classData = {
        code: this.prodClassCriteria.compositeArrayWrapper.classCode,
        flag: this.prodClassCriteria.compositeArrayWrapper.classFoundFlag,
      };
      return classData;
    },
    sortedLevelArray() {
      const sortedLevelAray = this.prodClassCriteria.levelArray;
      return sortedLevelAray;
    },
    arrayLengths() {
      const arrLengthHolder = {
        srch_cri_arr_len: this.prodClassCriteria.searchCriteriaArray
          ? this.prodClassCriteria.searchCriteriaArray.length
          : null,
        wf_resp_arr: this.prodClassCriteria.workflowResponseCache
          ? this.prodClassCriteria.workflowResponseCache.length
          : null,
      };
      return arrLengthHolder;
    },
    workflowDataArray() {
      const workflowDataArray = [];
      let indx = 0;
      const wfResponseCache = this.prodClassCriteria.workflowResponseCache;
      if (wfResponseCache && wfResponseCache.length > 0) {
        wfResponseCache.forEach((srchCritArrElement) => {
          if (srchCritArrElement) {
            const currTitleDataAndChildOptions = srchCritArrElement.response_data;
            const { choices } = srchCritArrElement;
            let answer = '';
            let levelComputed = '';
            let ruleRef = '';
            let intClass = '';
            if (Array.isArray(choices)) {
              choices.forEach((e) => {
                const valArray = e.split('|');
                answer += `${valArray[0]},`;
                levelComputed += `${valArray[2]},`;
                ruleRef += !valArray[6] ? `${valArray[6]},` : '';
                intClass += !valArray[5] ? `${valArray[5]},` : '';
              });
            } else {
              const valArray = choices.split('|');
              [answer] = valArray;
              levelComputed += valArray[2];
              [, , , , , , ruleRef] = valArray;
              [, , , , , intClass] = valArray;
            }

            const workflowDataIns = {
              step: (indx += 1),
              question: currTitleDataAndChildOptions.vital_characteristic,
              answer,
              level: levelComputed,
              interimClass: intClass,
              ruleRef,
            };
            workflowDataArray.push(workflowDataIns);
          }
        });
      }
      return workflowDataArray;
    }, */
    /**
     * This method uses interim class data's array and hides all complex logic and only exposes simple data to template.
     *
     */
    summarizedRiskClassRules() {
      const summarizedObj = {
        applicableRules: [],
        resultingRiskClass: [],
        highestClassRules: [],
      };
      let doOverRide = false;
      for (
        let idx = 0;
        idx < this.prodClassCriteria.interimClassDataArray.length;

      ) {
        const intrimDataIns = this.prodClassCriteria.interimClassDataArray[idx];
        if (intrimDataIns && intrimDataIns.int_class) {
          const applRuleVal = `${intrimDataIns.int_class_rule} (  ${intrimDataIns.int_class} )`;
          if (!summarizedObj.applicableRules.includes(applRuleVal)) {
            summarizedObj.applicableRules.push(applRuleVal);
          }
          if (intrimDataIns.class_override === 'Y') {
            doOverRide = true;
          } else if (!summarizedObj.resultingRiskClass[0]) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          } else if (
            intrimDataIns.int_class.localeCompare(
              summarizedObj.resultingRiskClass[0],
            ) > 0
          ) {
            summarizedObj.resultingRiskClass[0] = intrimDataIns.int_class;
            summarizedObj.resultingRiskClass[1] = intrimDataIns.class_notes;
          }
        }
        idx += 1;
      }
      /* This check required to do a proper override.Blood bags will always be Class IIb. */
      if (doOverRide === true) {
        if (
          this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y',
          )
        ) {
          summarizedObj.resultingRiskClass[0] = this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y',
          )[0].int_class;
          summarizedObj.resultingRiskClass[1] = this.prodClassCriteria.interimClassDataArray.filter(
            (element) => element.class_override === 'Y',
          )[0].class_notes;
        }
      }

      this.prodClassCriteria.interimClassDataArray.forEach((intrimDataIns) => {
        if (intrimDataIns) {
          if (
            summarizedObj.resultingRiskClass[0] === intrimDataIns.int_class
            && !summarizedObj.highestClassRules.includes(
              intrimDataIns.int_class_rule,
            )
          ) {
            summarizedObj.highestClassRules.push(intrimDataIns.int_class_rule);
          }
        }
      });
      summarizedObj.highestClassRules.sort((a, b) => b - a);
      // this.prodClassCriteria.compositeArrayWrapper.classRuleRef = summarizedObj.highestClassRules[0];
      return summarizedObj;
    },
  },
  /* mounted() {}, */
};
</script>
<style scoped>
.notification_box {
  min-height: 110px;
  position: relative;
  display: block;
  background: #ffffff;
  box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin-left: 20px;
  margin: 15px 20px 10px 20px;
  padding: 14px 10px 10px 2px;
}
.question_details {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.7);
}
.class_question {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 23px;
  display: flex;
  align-items: center;
  color: #00518a;
}
.padding_rl20 {
  padding-right: 20px;
  padding-left: 20px;
}
.class_question_summary {
  font-size: 15px;
  line-height: 23px;
}
.class-heading-notes {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  color: #0c3859;
}

.class-suggestion-notes {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}

.class-super-heading-notes {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  color: #0C3859;
}

.class-heading-notes-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  color: #0c3859;
}
.circle {
  width: 125px;
  height: 125px;
  border-radius: 50%;
  line-height: 125px;
  text-align: center;
  background: #4c9e45;
  font-size: 60px;
  color: white;
  margin: auto;
}

.hr {
  width: 100%;
  height: 10px;
  margin-left: auto;
  margin-right: auto;
  background-color: #4c9e45;
  border: 15 none;
  margin-top: 20px;
  margin-bottom: 20px;
}
.prev-slide {
  padding: 7px 31px;
}
.hr-thin {
  width: 100%;
  height: 2px;
  margin-left: auto;
  margin-right: auto;
  background: rgba(0, 0, 0, 0.4);
  border: 15 none;
  margin-top: 20px;
  margin-bottom: 20px;
}
.hr-thin-summary {
  width: 97%;
  height: 0.125px;
  margin-left: auto;
  margin-right: auto;
  background: rgba(0, 0, 0, 0.4);
  border: -0.5px dashed #BDBDBD;
  margin-top: 20px;
  margin-bottom: 20px;
}

.hr-thin-separator {
  width: 97%;
  height: 0.0825px;
  margin-left: auto;
  margin-right: auto;
  background: rgba(0, 0, 0, 0.4);
  border: -0.5px solid #BDBDBD;
  margin-top: 20px;
  margin-bottom: 20px;
}
.disclaimer {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 15px;
  margin-top: 16px;
}
.p-t10-b10 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.p-t20 {
  padding-top: 20px;
}

.p-l15-r15 {
  padding-left: 15px;
  padding-right: 15px;
}
.margin_top_bottom_15 {
  margin-bottom: 15px;
  margin-top: 6px;
}

.class-notes {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  color: rgba(0, 0, 0, 0.7);
}

.class-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 37px;
  text-align: center;
  color: rgba(0, 0, 0, 0.7);
}

.class-code-style {
  font-family: Roboto;
  font-style: normal;
  text-align: center;
  color: #FFFFFF;
}
.class-code-style-font {
  font-weight: 550;
  font-size: 60px;
  line-height: 70px;
}
.class-code-style-font-small {
  font-weight: 450;
  font-size: 50px;
  line-height: 60px;
}
</style>
